'use client';

import { useEffect } from 'react';
import { reportError } from '@core/lib/errorReporter';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, { digest: error.digest, source: 'error-page' });
  }, [error]);

  return (
    <div className="flex flex-1 items-center justify-center p-8">
      <div className="max-w-md text-center">
        <h2 className="mb-2 text-lg font-semibold text-text-0">This page couldn't load</h2>
        <p className="mb-6 text-sm text-text-2">
          There was a problem loading this page. This may be temporary. Try again in a moment.
        </p>
        <button
          onClick={() => reset()}
          className="rounded-md bg-bg-2 px-4 py-2 text-sm font-medium text-text-0 hover:bg-bg-3"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
